<template>
    <div class="matchGraph" :class="{matchGraphDark: isDark}">
        <div class="bgImg" v-if="$route.query.season == '2022'">
            <img src="../../assets/img/database/kteCupBg.png" alt="">
        </div>
        <div class="against">
            <div class="top">
                <div class="first">
                    <div class="col" v-for="(item,index) in data.leftFirstCol" :key="index">
                        <div class="colLeft" :class="{'teamDarkL' : item.winner == '1'}">
                            <div class="team team1">
                                <p class="img"><img :src="item.team1_logo_url" alt=""></p>
                                <p class="name">{{item.team1_name}}</p>
                            </div>
                        </div>
                        <div class="colRight" :class="{'teamDarkR' : item.winner == '2'}">
                            <div class="team team2" >
                                <p class="img"><img :src="item.team2_logo_url" alt=""></p>
                                <p class="name">{{item.team2_name}}</p>
                            </div>
                        </div>
                        <div class="bottom" :class="{'bottomLeft' : item.winner == '1', 'bottomRight' : item.winner == '2'}"></div>
                        <div class="score" v-if="item.score">
                            <p v-if="item.score">
                                <span :class="{light: item.score.team1 < item.score.team2}">{{ item.score.team1 }}</span>-<span :class="{light: item.score.team1 > item.score.team2}">{{ item.score.team2 }}</span>
                            </p>
                            <p v-if="item.score1">
                                <span :class="{light: item.score1.team1 < item.score1.team2}">{{ item.score1.team1 }}</span>-<span :class="{light: item.score1.team1 > item.score1.team2}">{{ item.score1.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scoreOt">
                                加时<span>{{ item.scoreOt.team1 }}</span>-<span>{{ item.scoreOt.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scorePt">
                                点球<span>{{ item.scorePt.team1 }}</span>-<span>{{ item.scorePt.team2 }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="second">
                    <div class="col" v-for="(item,index) in data.leftSecondCol" :key="index">
                        <div class="colLeft" :class="{'teamDarkL' : item.winner == '1'}">
                            <div class="team team1">
                                <p class="img"><img :src="item.team1_logo_url" alt=""></p>
                                <p class="name">{{item.team1_name}}</p>
                            </div>
                        </div>
                        <div class="colRight" :class="{'teamDarkR' : item.winner == '2'}">
                            <div class="team team2">
                                <p class="img"><img :src="item.team2_logo_url" alt=""></p>
                                <p class="name">{{item.team2_name}}</p>
                            </div>
                        </div>
                        <div class="bottom" :class="{'bottomLeft' : item.winner == '1', 'bottomRight' : item.winner == '2'}"></div>
                        <div class="score" v-if="item.score">
                            <p v-if="item.score">
                                <span :class="{light: item.score.team1 < item.score.team2}">{{ item.score.team1 }}</span>-<span :class="{light: item.score.team1 > item.score.team2}">{{ item.score.team2 }}</span>
                            </p>
                            <p v-if="item.score1">
                                <span :class="{light: item.score1.team1 < item.score1.team2}">{{ item.score1.team1 }}</span>-<span :class="{light: item.score1.team1 > item.score1.team2}">{{ item.score1.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scoreOt">
                                加时<span>{{ item.scoreOt.team1 }}</span>-<span>{{ item.scoreOt.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scorePt">
                                点球<span>{{ item.scorePt.team1 }}</span>-<span>{{ item.scorePt.team2 }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="third">
                    <div class="col">
                        <div class="colLeft" :class="{'teamDarkL' : data.leftThirdCol.winner == '1'}">
                            <div class="team team1">
                                <p class="img"><img :src="data.leftThirdCol.team1_logo_url" alt=""></p>
                                <p class="name">{{data.leftThirdCol.team1_name}}</p>
                            </div>
                        </div>
                        <div class="colRight" :class="{'teamDarkR' : data.leftThirdCol.winner == '2'}">
                            <div class="team team2">
                                <p class="img"><img :src="data.leftThirdCol.team2_logo_url" alt=""></p>
                                <p class="name">{{data.leftThirdCol.team2_name}}</p>
                            </div>
                        </div>
                        <div class="bottom" :class="{'bottomLeft' : data.leftThirdCol.winner == '1', 'bottomRight' : data.leftThirdCol.winner == '2'}"></div>
                        <div class="score" v-if="data.leftThirdCol.score">
                            <p v-if="data.leftThirdCol.score">
                                <span :class="{light:data.leftThirdCol.score.team1 < data.leftThirdCol.score.team2}">{{ data.leftThirdCol.score.team1 }}</span>-<span :class="{light:data.leftThirdCol.score.team1 > data.leftThirdCol.score.team2}">{{ data.leftThirdCol.score.team2 }}</span>
                            </p>
                            <p v-if="data.leftThirdCol.score1">
                                <span :class="{light:data.leftThirdCol.score1.team1 < data.leftThirdCol.score1.team2}">{{ data.leftThirdCol.score1.team1 }}</span>-<span :class="{light:data.leftThirdCol.score1.team1 > data.leftThirdCol.score1.team2}">{{ data.leftThirdCol.score1.team2 }}</span>
                            </p>
                            <p class="ot" v-if="data.leftThirdCol.scoreOt">
                                加时<span>{{ data.leftThirdCol.scoreOt.team1 }}</span>-<span>{{ data.leftThirdCol.scoreOt.team2 }}</span>
                            </p>
                            <p class="ot" v-if="data.leftThirdCol.scorePt">
                                点球<span>{{ data.leftThirdCol.scorePt.team1 }}</span>-<span>{{ data.leftThirdCol.scorePt.team2 }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mid">
                <div class="winBox">
                    <div class="team" :class="{win: data.finish.winner ==1}">
                        <p><img :src="data.finish.team1_logo_url" alt=""></p>
                        <p>{{data.finish.team1_name}}</p>
                    </div>
                    <div class="score" v-if="data.finish.score">
                        <p v-if="data.finish.score">
                            <span :class="{light:data.finish.score.team1 < data.finish.score.team2}">{{ data.finish.score.team1 }}</span>-<span :class="{light:data.finish.score.team1 > data.finish.score.team2}">{{ data.finish.score.team2 }}</span>
                        </p>
                        <p v-if="data.finish.score1">
                            <span :class="{light:data.finish.score1.team1 < data.finish.score1.team2}">{{ data.finish.score1.team1 }}</span>-<span :class="{light:data.finish.score1.team1 > data.finish.score1.team2}">{{ data.finish.score1.team2 }}</span>
                        </p>
                        <p class="ot" v-if="data.finish.scoreOt">
                            加时<span>{{ data.finish.scoreOt.team1 }}</span>-<span>{{ data.finish.scoreOt.team2 }}</span>
                        </p>
                        <p class="ot" v-if="data.finish.scorePt">
                            点球<span>{{ data.finish.scorePt.team1 }}</span>-<span>{{ data.finish.scorePt.team2 }}</span>
                        </p>
                    </div>
                    <div class="team" :class="{win: data.finish.winner ==2}">
                        <p><img :src="data.finish.team2_logo_url" alt=""></p>
                        <p>{{data.finish.team2_name}}</p>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="third">
                    <div class="col">
                        <div class="colLeft" :class="{'teamDarkL' : data.rightThirdCol.winner == '1'}">
                            <div class="team team1">
                                <p class="img"><img :src="data.rightThirdCol.team1_logo_url" alt=""></p>
                                <p class="name">{{data.rightThirdCol.team1_name}}</p>
                            </div>
                        </div>
                        <div class="colRight" :class="{'teamDarkR' : data.rightThirdCol.winner == '2'}">
                            <div class="team team2">
                                <p class="img"><img :src="data.rightThirdCol.team2_logo_url" alt=""></p>
                                <p class="name">{{data.rightThirdCol.team2_name}}</p>
                            </div>
                        </div>
                        <div class="bottom" :class="{'bottomLeft' : data.rightThirdCol.winner == '1', 'bottomRight' : data.rightThirdCol.winner == '2'}"></div>
                        <div class="score" v-if="data.rightThirdCol.score">
                            <p v-if="data.rightThirdCol.score">
                                <span :class="{light:data.rightThirdCol.score.team1 < data.rightThirdCol.score.team2}">{{ data.rightThirdCol.score.team1 }}</span>-<span :class="{light:data.rightThirdCol.score.team1 > data.rightThirdCol.score.team2}">{{ data.rightThirdCol.score.team2 }}</span>
                            </p>
                            <p v-if="data.rightThirdCol.score1">
                                <span :class="{light:data.rightThirdCol.score1.team1 < data.rightThirdCol.score1.team2}">{{ data.rightThirdCol.score1.team1 }}</span>-<span :class="{light:data.rightThirdCol.score1.team1 > data.rightThirdCol.score1.team2}">{{ data.rightThirdCol.score1.team2 }}</span>
                            </p>
                            <p class="ot" v-if="data.rightThirdCol.scoreOt">
                                加时<span>{{ data.rightThirdCol.scoreOt.team1 }}</span>-<span>{{ data.rightThirdCol.scoreOt.team2 }}</span>
                            </p>
                            <p class="ot" v-if="data.rightThirdCol.scorePt">
                                点球<span>{{ data.rightThirdCol.scorePt.team1 }}</span>-<span>{{ data.rightThirdCol.scorePt.team2 }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="second">
                    <div class="col" v-for="(item,index) in data.rightSecondCol" :key="index">
                        <div class="colLeft" :class="{'teamDarkL' : item.winner == '1'}">
                            <div class="team team1">
                                <p class="img"><img :src="item.team1_logo_url" alt=""></p>
                                <p class="name">{{item.team1_name}}</p>
                            </div>
                        </div>
                        <div class="colRight" :class="{'teamDarkR' : item.winner == '2'}">
                            <div class="team team2">
                                <p class="img"><img :src="item.team2_logo_url" alt=""></p>
                                <p class="name">{{item.team2_name}}</p>
                            </div>
                        </div>
                        <div class="bottom" :class="{'bottomLeft' : item.winner == '1', 'bottomRight' : item.winner == '2'}"></div>
                        <div class="score" v-if="item.score">
                            <p v-if="item.score">
                                <span :class="{light: item.score.team1 < item.score.team2}">{{ item.score.team1 }}</span>-<span :class="{light: item.score.team1 > item.score.team2}">{{ item.score.team2 }}</span>
                            </p>
                            <p v-if="item.score1">
                                <span :class="{light: item.score1.team1 < item.score1.team2}">{{ item.score1.team1 }}</span>-<span :class="{light: item.score1.team1 > item.score1.team2}">{{ item.score1.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scoreOt">
                                加时<span>{{ item.scoreOt.team1 }}</span>-<span>{{ item.scoreOt.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scorePt">
                                点球<span>{{ item.scorePt.team1 }}</span>-<span>{{ item.scorePt.team2 }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="first">
                    <div class="col" v-for="(item,index) in data.rightFirstCol" :key="index">
                        <div class="colLeft" :class="{'teamDarkL' : item.winner == '1'}">
                            <div class="team team1">
                                <p class="img"><img :src="item.team1_logo_url" alt=""></p>
                                <p class="name">{{item.team1_name}}</p>
                            </div>
                        </div>
                        <div class="colRight" :class="{'teamDarkR' : item.winner == '2'}">
                            <div class="team team2">
                                <p class="img"><img :src="item.team2_logo_url" alt=""></p>
                                <p class="name">{{item.team2_name}}</p>
                            </div>
                        </div>
                        <div class="bottom" :class="{'bottomLeft' : item.winner == '1', 'bottomRight' : item.winner == '2'}"></div>
                        <div class="score" v-if="item.score">
                            <p v-if="item.score">
                                <span :class="{light: item.score.team1 < item.score.team2}">{{ item.score.team1 }}</span>-<span :class="{light: item.score.team1 > item.score.team2}">{{ item.score.team2 }}</span>
                            </p>
                            <p v-if="item.score1">
                                <span :class="{light: item.score1.team1 < item.score1.team2}">{{ item.score1.team1 }}</span>-<span :class="{light: item.score1.team1 > item.score1.team2}">{{ item.score1.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scoreOt">
                                加时<span>{{ item.scoreOt.team1 }}</span>-<span>{{ item.scoreOt.team2 }}</span>
                            </p>
                            <p class="ot" v-if="item.scorePt">
                                点球<span>{{ item.scorePt.team1 }}</span>-<span>{{ item.scorePt.team2 }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'matchGraph',
    props: ['data'],
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    }
}
</script>

<style lang="less" scoped>
.matchGraph {
    min-height: 300px;
    position: relative;
    padding: 0 10px;
    padding-bottom: 20px;
    .bgImg {
        width: 234px;
        height: 229px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .against {
        .col {
            display: flex;
            position: relative;
            .colLeft, .colRight {
                flex: 1;
                position: relative;
                .team {
                    width: 35px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .name {
                        width: 100%;
                        margin-top: 3px;
                        font-size: 9px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        color: #999;
                    }
                }
            }
            .score {
                width: 100%;
                height: 15px;
                font-size: 9px;
                font-weight: 600;
                color: #333333;
                line-height: 15px;
                text-align: center;
                position: absolute;
                height: 48px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .light{
                    color: #999
                }
                .ot{
                    color: #999;
                }
            }
        }
        .top {
            .score{
                top: -16px;
            }
            .col {
                .bottom {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 14px;
                    border-left: 1px solid #d9d9d9;
                    border-right: 1px solid #d9d9d9;
                }
                .bottomLeft {
                    border-left-color: #169AFF;
                }
                .bottomRight {
                    border-right-color: #169AFF;
                }
                .teamDarkL {
                    border-bottom-color: #169AFF !important;
                    .name{
                        color: #333;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #169AFF !important;
                        right: -0.5px;
                        bottom: -16px;
                        z-index: 1;
                    }
                }
                .teamDarkR {
                    border-bottom-color: #169AFF !important;
                    .name{
                        color: #333 !important;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #169AFF !important;
                        left: -0.5px;
                        bottom: -16px;
                        z-index: 1;
                    }
                }
                .colLeft, .colRight {
                    border-bottom: 1px solid #d9d9d9;
                }
                .colLeft {
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #d9d9d9;
                        right: -0.5px;
                        bottom: -16px;
                    }
                }
                .colRight {
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #d9d9d9;
                        left: -0.5px;
                        bottom: -16px;
                    }
                }
            }
            .first {
                display: flex;
                justify-content: space-between;
                .col {
                    width: 48px;
                    height: 55px;
                    .colLeft, .colRight {
                        .team {
                            position: absolute;
                            .img {
                                width: 18px;
                                // height: 11px;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .name {
                                font-size: 9px;
                                font-weight: 400;
                            }
                        }
                        .team1 {
                            top: -2px;
                            left: -15px;
                        }
                        .team2 {
                            top: -2px;
                            right: -15px;
                        }
                    }
                }
            }
            .second {
                padding: 0 22px;
                padding-top: 17px;
                display: flex;
                justify-content: space-between;
                .col {
                    width: 98px;
                    height: 55px;
                    .colLeft, .colRight {
                        .team {
                            position: absolute;
                            .img {
                                width: 18px;
                                img {
                                    width: 100%;
                                    // height: 100%;
                                }
                            }
                            .name {
                                font-size: 9px;
                                font-weight: 400;
                            }
                        }
                        .team1 {
                            top: 0;
                            left: -15px;
                        }
                        .team2 {
                            top: 0;
                            right: -15px;
                        }
                    }
                }
            }
            .third {
                padding-top: 12px;
                display: flex;
                justify-content: center;
                .col {
                    width: 192px;
                    height: 55px;
                    .colLeft, .colRight {
                        .team {
                            position: absolute;
                            .img {
                                width: 18px;
                                // height: 19px;
                                img {
                                    width: 100%;
                                    // height: 100%;
                                }
                            }
                            .name {
                                font-size: 9px;
                                font-weight: 400;
                            }
                        }
                        .team1 {
                            top: 0;
                            left: -15px;
                        }
                        .team2 {
                            top: 0;
                            right: -15px;
                        }
                    }
                    .score {
                        top: -15px;
                    }
                }
            }
        }
        .mid {
            display: flex;
            justify-content: center;
            .winBox {
                // width: 184px;
                height: 70px;
                display: flex;
                div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
                .team {
                    flex: none;
                    width: 70px;
                    p {
                        width: 100%;
                        font-size: 9px;
                        font-weight: 400;
                        color: #999;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        img {
                            width: 18px;
                        }
                    }
                }
                .win p{
                    color: #333 !important;
                }
                .score {
                    flex: none;
                    width: 60px;
                    p {
                        font-size: 9px;
                        font-weight: 600;
                        color: #333333;
                    }
                    .ot{
                        color:#999;
                    }
                }
            }
        }
        .bottom {
            .col {
                .bottom {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 14px;
                    border-left: 1px solid #d9d9d9;
                    border-right: 1px solid #d9d9d9;
                }
                .bottomLeft {
                    border-left-color: #169AFF;
                }
                .bottomRight {
                    border-right-color: #169AFF;
                }
                .teamDarkL {
                    border-top-color: #169AFF !important;
                    .name{
                        color: #333;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #169AFF !important;
                        right: -0.5px;
                        top: -16px;
                        z-index: 1;
                    }
                }
                .teamDarkR {
                    border-top-color: #169AFF !important;
                    .name{
                        color: #333;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #169AFF !important;
                        left: -0.5px;
                        top: -16px;
                        z-index: 1;
                    }
                }
                .colLeft, .colRight {
                    border-top: 1px solid #d9d9d9;
                }
                .colLeft {
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #d9d9d9;
                        right: -0.5px;
                        top: -16px;
                    }
                }
                .colRight {
                    &::after {
                        content: '';
                        position: absolute;
                        width: 1px;
                        height: 16px;
                        background: #d9d9d9;
                        left: -0.5px;
                        top: -16px;
                    }
                }
            }
            .third {
                padding-bottom: 17px;
                display: flex;
                justify-content: center;
                .col {
                    width: 192px;
                    height: 55px;
                    .colLeft, .colRight {
                        .team {
                            position: absolute;
                            .img {
                                width: 18px;
                                // height: 19px;
                                img {
                                    width: 100%;
                                    // height: 100%;
                                }
                            }
                            .name {
                                font-size: 9px;
                                font-weight: 400;
                            }
                        }
                        .team1 {
                            bottom: 0;
                            left: -15px;
                        }
                        .team2 {
                            bottom: 0;
                            right: -15px;
                        }
                    }
                    .score {
                        bottom: 8px;
                    }
                }
            }
            .second {
                padding: 0 22px;
                padding-bottom: 17px;
                display: flex;
                justify-content: space-between;
                .col {
                    width: 98px;
                    height: 55px;
                    .colLeft, .colRight {
                        .team {
                            position: absolute;
                            .img {
                                width: 18px;
                                // height: 17px;
                                img {
                                    width: 100%;
                                    // height: 100%;
                                }
                            }
                            .name {
                                font-size: 9px;
                                font-weight: 400;
                            }
                        }
                        .team1 {
                            bottom: 0;
                            left: -15px;
                        }
                        .team2 {
                            bottom: 0;
                            right: -15px;
                        }
                    }
                    .score {
                        // top: 5px;
                        bottom: 8px;
                    }
                }
            }
            .first {
                display: flex;
                justify-content: space-between;
                .col {
                    width: 48px;
                    height: 55px;
                    .colLeft, .colRight {
                        .team {
                            position: absolute;
                            .img {
                                width: 18px;
                                height: 17px;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .name {
                                font-size: 9px;
                                font-weight: 400;
                            }
                        }
                        .team1 {
                            bottom: -2px;
                            left: -15px;
                        }
                        .team2 {
                            bottom: -2px;
                            right: -15px;
                        }
                    }
                    .score {
                        bottom: 0px;
                    }
                }
            }
        }
    }
}
.matchGraphDark{
    .against {
        .col{
            .score{
                color: #d3d3d3;
                .light, .ot{
                    color: #595959;
                }
            }
        }
        .top{
            .col{
                .teamDarkL{
                    .name{
                        color: #d3d3d3 !important;
                    }
                }
                .teamDarkR{
                    .name{
                        color: #d3d3d3 !important;
                    }
                }
            }
        }
        .mid{
            .winBox{
                .team p{
                    color: #595959;
                }
                .win p{
                    color: #d3d3d3 !important;
                }
                .score{
                    p{
                        color: #d3d3d3;
                    }
                    .ot{
                        color: #595959;
                    }
                }
            }
        }
        .bottom{
            .col{
                .teamDarkL, .teamDarkR {
                    .name{
                        color: #d3d3d3;;
                    }
                }
            }
        }
    }
}
</style>
